<h1 class="tds-expressive-headline-01 tds-u-flex tds-u-justify-center">
  CONTROL PASS
</h1>

<div class="tds-u-flex tds-u-justify-center">
  <app-button text="GERAR SENHA" (clicked)="gerarSenha()"></app-button>
</div>
